import { useNavigate } from 'react-router-dom';
import { updateField } from 'store/satisfactionSlice';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useUpdateSatisfactionMutation } from "store/api";
import useTranslation from './useTranslation';
import { addNotification } from 'store/componentsSlice';
import { setSatisfactionGoBack } from 'store/commonSlice';
import { getAppUrl } from 'utils/defines';

interface SatisfactionFormData {
  ACCESS_FACILITY?: number;
  ERGONOMY?: number;
  SIMPLICITY?: number;
  INTUITIVENESS?: number;
  FIABILITY?: number;
  RAPIDITY?: number;
  LISIBILITY?: number;
  INFORMATIONS?: number;
  DESIGN?: number;

  TOOL_GIVE_HELP_SATISFACTION?: string;
  GIVE_IT_HELP_SATISFACTION?: string;
  GIVE_IT_HELP_PLUS_SATISFACTION?: string;
  SUGGESTION?: string;
  APP_IS_HELPFULL?: string;

  [key: string]: any; // For other dynamic fields
}

export const useSatisfactionForm = () => {
  const dispatch = useAppDispatch();
  const formData = useAppSelector((state) => state.satisfaction) as SatisfactionFormData;
  const commonState = useAppSelector((state) => state.common);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [updateSatisfaction, { isLoading }] = useUpdateSatisfactionMutation();

  const handleFieldChange = (field: string, value: any) => {
    // debugger;
    dispatch(updateField({
      field,
      value: value !== undefined ? value : ''
    }));
  };

  const submitForm = async () => {
    try {
      const result = await updateSatisfaction(formData).unwrap();

      localStorage.setItem('satisfactionLastDemand', 'filled');
      dispatch(addNotification({
        type: 'success',
        message: t('SATISFACTION_SEND_SUCCESS'),
        duration: 3,
      }));

      if (commonState.satisfactionGoBack) {
        dispatch(setSatisfactionGoBack(false));
        navigate(getAppUrl('/project/synthesis'))
      } else {
        navigate(getAppUrl('/'))
      }
      

      // dispatch(resetForm());
      return result;
    } catch (error) {
      console.error('Error submitting satisfaction form:', error);
      dispatch(addNotification({
        type: 'error',
        message: t('SATISFACTION_SEND_ERROR'),
        duration: 3,
      }));
      throw error; // Re-throw if you want to handle it in the component
    }
  };

  return {
    formData,
    handleFieldChange,
    submitForm,
    isSubmitting: isLoading
  };
};